import { BrowserRouter } from 'react-router-dom'

import { AppRoutes } from './routes'
import { FoodProvider } from './context/FoodContext'
import { CartProvider } from './context/CartContext'
import { UserProvider } from './context/UserContext'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { Theme } from './styles/Theme'
import { GlobalStyle } from './styles/global'
import { Normalize } from 'styled-normalize'


export default function App() {
  return (
    <BrowserRouter>
      <Theme>
        <FoodProvider>
          <CartProvider>
            <UserProvider>
              <AppRoutes />
              <ToastContainer autoClose={600} />
              <GlobalStyle />
              <Normalize />
            </UserProvider>
          </CartProvider>
        </FoodProvider>
      </Theme>
    </BrowserRouter>
  )
}
